const faqs = [
  {
    q: 'O que é CSSBuy Spreadsheet?',
    a: 'CSSBuy Spreadsheet é uma planilha organizada com links diretos para os melhores produtos disponíveis no CSSBuy. Nela você encontra itens verificados em diversas categorias como Shoes, Hoodies, T-Shirts, Jackets e muito mais, tudo atualizado e organizado em português para facilitar suas compras.',
  },
  {
    q: 'Como usar o CSSBuy Spreadsheet?',
    a: 'Usar nossa CSSBuy Spreadsheet é simples: escolha uma categoria, clique no link do produto desejado e você será redirecionado diretamente para a página de compra. Recomendamos ler nossos guias completos para entender cada etapa do processo de importação.',
  },
  {
    q: 'O CSSBuy é seguro?',
    a: 'Sim, o CSSBuy é uma plataforma segura quando utilizada corretamente. Nossa spreadsheet inclui apenas produtos de vendedores verificados, com bom histórico de vendas e avaliações positivas. Sempre recomendamos verificar as fotos reais e o feedback antes de comprar.',
  },
  {
    q: 'Qual é a melhor spreadsheet do CSSBuy?',
    a: 'A nossa CSSBuy Spreadsheet é considerada a melhor em português por ser atualizada diariamente, incluir mais de 14 categorias de produtos e oferecer guias completos. Cada link é verificado manualmente para garantir que funcione e leve ao produto correto.',
  },
  {
    q: 'Como comprar usando CSSBuy?',
    a: 'Para comprar usando CSSBuy: (1) Escolha um produto na nossa spreadsheet, (2) Copie o link, (3) Cole na barra de busca do CSSBuy, (4) Selecione tamanho e cor, (5) Adicione ao carrinho, (6) Finalize a compra escolhendo o método de envio. Consulte nosso guia completo para mais detalhes.',
  },
  {
    q: 'Como economizar no frete do CSSBuy?',
    a: 'Para economizar no frete: combine múltiplos produtos em um único envio, escolha linhas de frete econômicas, aproveite promoções sazonais e utilize cupons de desconto. Nossa spreadsheet inclui dicas específicas de frete para cada categoria de produto.',
  },
  {
    q: 'Como encontrar produtos no CSSBuy?',
    a: 'A maneira mais fácil é usar nossa CSSBuy Spreadsheet, que organiza os produtos por categorias com links diretos. Você também pode usar a busca por imagem no CSSBuy, pesquisar por palavras-chave específicas ou navegar pelas categorias dentro da plataforma.',
  },
  {
    q: 'O CSSBuy funciona no Brasil?',
    a: 'Sim, o CSSBuy funciona perfeitamente no Brasil. A plataforma oferece diversas opções de frete internacional para o Brasil, com prazos que variam de 10 a 45 dias dependendo da modalidade escolhida. Nossos guias incluem instruções específicas para compradores brasileiros.',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-16 md:py-24 px-6 md:px-10 bg-background-50">
      <div className="max-w-[800px] mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center px-4 py-1.5 rounded-full border border-background-300/60 mb-5">
            <span className="text-xs font-medium text-foreground-600 tracking-wide">FAQ</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
            Perguntas sobre
            <br />
            <span className="font-heading italic font-normal text-foreground-700">CSSBuy Spreadsheet</span>
          </h2>
        </div>

        {/* FAQ accordion */}
        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <details key={idx} className="group border border-background-200/70 rounded-xl bg-background-50 overflow-hidden">
              <summary className="flex items-center justify-between px-6 py-4 cursor-pointer list-none">
                <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {faq.q}
                </span>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full bg-background-100 text-foreground-500 group-open:bg-primary-500 group-open:text-white transition-colors">
                  <i className="ri-add-line text-sm group-open:hidden"></i>
                  <i className="ri-subtract-line text-sm hidden group-open:block"></i>
                </div>
              </summary>
              <div className="px-6 pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>

      {/* FAQ Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.q,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.a,
              },
            })),
          }),
        }}
      />
    </section>
  );
}